module.exports = __webpack_public_path__ + "img/hero.569c1e40.jpg";